import { Box, Flex } from '@chakra-ui/react';
import {
  DetectionQueryVariables,
  SantizedDetection,
} from '../../../../../../pages';
import { useContext, useState } from 'react';
import { AuthContext } from '../../../../../../../../shared/providers/AuthProvider/AuthContext';
import { SendToPill } from '../../../../../DetectionPills';
import { DetectionStatusPill } from '../../../../../DetectionStatusPill';
import { DetectionStatusActionsMenu } from '../../../../../DetectionStatusPopover';
import { IGetDetectionVariables } from '../../SummaryPanel';
import { Detection } from '@investigator/shared/generated/graphql';

interface DetectionStatusProps {
  refetchMain?: boolean;
  detectionStatus?: string;
  detectionInfo?: Detection | SantizedDetection;
  getDetectionVariables?: IGetDetectionVariables;
  queryDetectionsPaginatedVariables?: DetectionQueryVariables;
}

export const DetectionStatus = ({
  refetchMain,
  detectionInfo,
  detectionStatus,
  getDetectionVariables,
  queryDetectionsPaginatedVariables,
}: DetectionStatusProps) => {
  const { userRole } = useContext(AuthContext);
  const [isStatusHovered, setIsStatusHovered] = useState(false);

  if (userRole === 'viewer') {
    return (
      <Flex wrap="wrap" gap={2} maxW="100%" align="flex-start" mr={2}>
        {detectionStatus && (
          <DetectionStatusPill
            text={detectionStatus}
            isStatusOpen={detectionStatus === 'open'}
          />
        )}
        {detectionInfo?.escalation_data?.escalation_status && (
          <SendToPill escalation_data={detectionInfo.escalation_data} />
        )}
      </Flex>
    );
  }

  return (
    <Flex
      w="100%"
      p="2px 4px"
      minH="28px"
      borderRadius="2px"
      alignItems="flex-start"
      position="relative"
      wordBreak="break-word"
      transition="all .1s ease-out"
      data-testid="summary-panel-inline-edit-status"
      onMouseOver={() => setIsStatusHovered(true)}
      onMouseLeave={() => setIsStatusHovered(false)}
      wrap="wrap"
      gap={2}
      maxW="100%"
      _hover={{
        backgroundColor: isStatusHovered ? 'whiteAlpha.50' : 'transparent',
      }}
    >
      <Flex
        flex="1"
        wrap="wrap"
        direction={{ base: 'column', sm: 'row' }}
        align="flex-start"
        minW="0"
        maxW="100%"
        overflow="hidden"
        gap={2}
      >
        {detectionStatus && (
          <Box maxW="100%" overflow="hidden">
            <DetectionStatusPill
              text={detectionStatus}
              isStatusOpen={detectionStatus === 'open'}
            />
          </Box>
        )}
        {detectionInfo?.escalation_data?.escalation_status && (
          <Box maxW="100%" overflow="hidden">
            <SendToPill escalation_data={detectionInfo.escalation_data} />
          </Box>
        )}
      </Flex>

      <Box
        w="24px"
        h="24px"
        minW="24px"
        minH="24px"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        visibility={isStatusHovered ? 'visible' : 'hidden'}
        pointerEvents={isStatusHovered ? 'auto' : 'none'}
        flexShrink={0}
        flexGrow={0}
      >
        <DetectionStatusActionsMenu
          refetchMain={refetchMain}
          isStatusHovered={isStatusHovered}
          getDetectionVariables={getDetectionVariables}
          queryDetectionsPaginatedVariables={queryDetectionsPaginatedVariables}
        />
      </Box>
    </Flex>
  );
};
